// 神器装备
import { EquipMain } from "../equipmentType";
import { equipTypes } from "../equipConst";
import { propertyName, propertyAttr } from "@/const/character";
// 武器池
const equipPoolListW: EquipMain[] = [
  {
    name: "屠杀",
    describe: "我渴望...鲜血...",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 80
      },
      {
        name: propertyName.AS,
        type: propertyAttr.AS,
        isPercent: false,
        value: 0.3
      },
      {
        name: propertyName.CRR,
        type: propertyAttr.CRR,
        isPercent: false,
        value: 0.1
      }
    ],
    grade: 3,
    level: 10,
    icon: 6,
    price: 500
  },
  {
    name: "流星堕",
    describe: "鲜血伴着流星划过",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 70
      },
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: 300
      },
      {
        name: propertyName.DEX,
        type: propertyAttr.DEX,
        isPercent: false,
        value: 20
      }
    ],
    grade: 3,
    level: 10,
    icon: 8,
    price: 500
  },
  {
    name: "心灵撕裂者",
    describe: "体之伤，可愈矣。心之殇，难愈也",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 97
      },
      {
        name: propertyName.AS,
        type: propertyAttr.AS,
        isPercent: false,
        value: 0.24
      },
      {
        name: propertyName.CRD,
        type: propertyAttr.CRD,
        isPercent: false,
        value: 0.35
      }
    ],
    grade: 3,
    level: 15,
    icon: 7,
    price: 750
  },
  {
    name: "蛇眼聚光剑",
    describe: "不用眼睛，我也能杀了你，嘶嘶~~",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 120
      },
      {
        name: propertyName.CRD,
        type: propertyAttr.CRD,
        isPercent: false,
        value: 0.2
      },
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 60
      }
    ],
    grade: 3,
    level: 20,
    icon: 29,
    price: 1000
  }
];
// 防具池
const equipPoolListA: EquipMain[] = [
  {
    name: "烦风衣",
    describe: "这背心能行吗",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: 250
      },
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 25
      },
      {
        name: propertyName.DEX,
        type: propertyAttr.DEX,
        isPercent: false,
        value: 25
      }
    ],
    grade: 3,
    level: 10,
    icon: 13,
    price: 500
  },
  {
    name: "铁壳禁卫军之甲",
    describe: "吾军将士，坚不可摧",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 250
      },
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 250
      }
    ],
    grade: 3,
    level: 15,
    icon: 10,
    price: 750
  },
  {
    name: "鬼巫之袍",
    describe: "阳寿换力量，阴间玩意",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: -99
      },
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: -133
      },
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 200
      },
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 80
      }
    ],
    grade: 3,
    level: 21,
    icon: 34,
    price: 900
  }
];
// 首饰池
const equipPoolListJ: EquipMain[] = [
  {
    name: "碧影",
    describe: "凝光碧玉",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.DEX,
        type: propertyAttr.DEX,
        isPercent: false,
        value: 30
      },
      {
        name: propertyName.AS,
        type: propertyAttr.AS,
        isPercent: false,
        value: 0.2
      },
      {
        name: propertyName.CRD,
        type: propertyAttr.CRD,
        isPercent: false,
        value: 0.2
      }
    ],
    grade: 3,
    level: 10,
    icon: 21,
    price: 500
  },
  {
    name: "气气之息",
    describe: "掌握气在身体之间的流动",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 40
      },
      {
        name: propertyName.CRR,
        type: propertyAttr.CRR,
        isPercent: false,
        value: 0.3
      },
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 25
      }
    ],
    grade: 3,
    level: 15,
    icon: 16,
    price: 750
  },
  {
    name: "炽热之力",
    describe: "我感觉火热的生命之息在我体内流淌！啊啊啊啊~",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 188
      },
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 88
      },
      {
        name: propertyName.CRD,
        type: propertyAttr.CRD,
        isPercent: false,
        value: -0.3
      },
      {
        name: propertyName.CRR,
        type: propertyAttr.CRR,
        isPercent: false,
        value: -0.1
      }
    ],
    grade: 3,
    level: 22,
    icon: 40,
    price: 1000
  }
];

const equipsGrade3: EquipMain[] = [
  ...equipPoolListW,
  ...equipPoolListA,
  ...equipPoolListJ
];
export { equipsGrade3 };
